export default __webpack_public_path__ + "static/media/card-3.ba9e3c5e.jpeg";